wbApp.filter('classroom', ['classroomSvc', '$translate', function (classroomSvc, $translate) {
    var models = classroomSvc.getAllAsync();

    function asyncResult(input) {
        if (models.$resolved) {
            var model = _.find(models, { id:  Number(input) });
            if (model) {
                if (model.isDeleted) {
                    return model.name + ' (' + $translate.instant('TXT_VAL_DELETED') + ')';
                }
                if (!model.active) {
                    return model.name + ' (' + $translate.instant('TXT_VAL_NOT_ACTIVE') + ')';
                }
                return model.name;
            } else {
                return '';
            }
        } else {
            return $translate.instant('TXT_LOADING_DATA');
        }
    }

    asyncResult.$stateful = true;

    return asyncResult;
}]);